<template>
  <div style="background:#f3f3f3;">
      <div class="wapper overf" >
	<div class="part">
       <img src="../../static/img/banner.png" width="100%"  />
	</div>
</div>


    <div class="wapper overf">
        <div class="part main-box2" style="background:#fff; padding:50px;">
            <div class="h f18 h44 cGray6 p_t_15" style="border-bottom:2px solid #ddd; padding-bottom:15px; margin-bottom:15px;">
                <p class="t-center b cRed2 f22 p_b_10">欢迎进入中共湖南省委组织部“12380”举报网站</p>
                <p class="t-indent">本网站主要受理全省各级领导班子和领导干部违反《党政领导干部选拔任用工作条例》及有关政策法规选人用人和省委拟提拔的领导干部人选存在问题的举报。如果您反映涉法涉诉、违纪违法等其他方面的问题，请直接向有关部门反映。</p>
                <p class="t-indent">感谢您对我们的信任和支持！</p>
            </div>
            <!-- <div class="tit3a"><span>受理范围</span></div>
            <div class="h f18 h44 cGray3 p_t_15">
                <p>1. 中共湖南省委组织部负责受理本网站的举报，并本着“分级负责、归口办理、认真调查、严肃处理”的原则进行核查。</p>
                <p>2. 根据举报反映的问题，中共湖南省委组织部直接办理或督促有关地方、单位组织人事部门承办。对群众反映的性质严重、内
                    容具体、线索清楚的选人用人问题，立项督查、限期处结。</p>
                <p>3. 经查问题属实的，依据有关规定，坚决纠正、严格问责；严重违反规定、已构违纪违法的，移交执纪执法机关处理。</p>
                <p>4. 严格执行保密制度，切实保护举报人的合法权益。对打击报复举报人的行为，严肃追究有关人员的责任。</p>
            </div> -->
            
            <div class="m_t_30 t-center"><a @click="notice" class="button button-caution button-rounded " style="background:#b00;">我要举报</a>
            <a @click="query" class="button button-caution button-rounded " style="background:#b00;">我要查询</a></div>
            
        </div>
    </div>

    <div class="clear overf m_t_40"></div>
    <!---- foot ---->
    <div class="wapper overf p_b_10" style="background:#AD0C1D;" >
    <div class="part p_t_20 h26 cWhite f14 overf" >
        <div class="t-center">	
                <p class=" p_l_10 ">
    Copyright© 2010.中共湖南省委组织部举报中心 All Rights Reserved 
                </p>
                 <p class=" p_l_10 ">
    备案号：<a href="http://beian.miit.gov.cn/" target="_blank">湘ICP备17016663号-2</a>
                </p>
        </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods:{
      notice(){
          this.$router.push({name:'area'})
      },
      query(){
          this.$router.push({name:'query'})
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/index.vue